// extracted by mini-css-extract-plugin
module.exports = {"clickableTableRow":"Table_clickableTableRow__FvP8_"};